import { ReactElement } from 'react'
import { Heading, Text, SVG } from '../../Atoms'
import { ConfirmationProps } from './props'
import { StyledConfirmation, StyledIcon } from './styles'
import { CheckCircleFilled } from '../../Assets/Icons'

const Confirmation = ({
    level = 1,
    size,
    iconLevel = 1,
    ...props
}: ConfirmationProps): ReactElement => {
    const { icon = <SVG src={CheckCircleFilled} />, text, headingText } = props

    return (
        <StyledConfirmation>
            <StyledIcon size={size ?? iconLevel}>{icon}</StyledIcon>
            <Heading
                size={size ?? level}
                fontWeight="600"
                css={{ color: '$secondary500' }}
            >
                {headingText}
            </Heading>
            <Text size="s" css={{ color: '$neutral400' }}>
                {text}
            </Text>
        </StyledConfirmation>
    )
}

export default Confirmation
export { StyledConfirmation }
